import React, { FC, useCallback } from 'react';
import { observer } from 'mobx-react';

export interface IHTMLAttributes {
  [key: string] : string;
}

interface IProps {
  imageSource: string;
  attributes?: IHTMLAttributes;
  className: string;
}

/*
  This component was written for avoid cashing previous
  source of image during load new one
  looks better when use see loading process
  instead old image
*/
const ImageLoadContainer: FC<IProps> = ({ imageSource, className, attributes= {}}) => {
  const imgRef = useCallback((img: HTMLImageElement) => {
    if(!img) return;
    img.src = '';
    img.src = imageSource;
  }, [imageSource]);

  return (
    <img
      className={className}
      ref={imgRef}
      {...attributes}
    />
  );
};

export default observer(ImageLoadContainer);